import { render } from "./FormFileHeader.vue?vue&type=template&id=6cd2be4b&scoped=true"
import script from "./FormFileHeader.vue?vue&type=script&lang=js"
export * from "./FormFileHeader.vue?vue&type=script&lang=js"

import "./FormFileHeader.vue?vue&type=style&index=0&id=6cd2be4b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cd2be4b"

export default script